module.exports = __webpack_public_path__ + "b23e3c76c483ca1767950739b3bb8662.jpg";